import React, { useState } from 'react';
import { CONTACT_CONFIG } from '../config/contact';

// Utilisation des variables de configuration centralisées
const contactInfo = CONTACT_CONFIG;

const faqData = [
  {
    question: "Le prix est-il mensuel ? Serai-je facturé à nouveau ?",
    answer: "Non, c'est un paiement unique. Nous ne facturons pas de frais mensuels et nous ne renouvelons pas automatiquement votre abonnement. Vous payez une seule fois et obtenez l'accès pour la période choisie (par exemple, un an, 15 mois ou 24 mois)."
  },
  {
    question: "Comment recevoir mon abonnement ?",
    answer: (
      <>
        Après le paiement, vous recevrez vos identifiants par e-mail dans les 10 à 30 minutes. Vérifiez votre dossier spam.  
        Si vous ne recevez rien, contactez-nous par WhatsApp :{" "}
        <a href={contactInfo.whatsappUrl} target="_blank" rel="noopener noreferrer" className='text-[#090979] hover:text-[#090979] font-semibold' style={{ display: "inline-flex", alignItems: "center", gap: "4px" }}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M20.52 3.48A11.77 11.77 0 0 0 12.04 0C5.39 0 .02 5.37.02 12.02c0 2.12.55 4.18 1.59 6.01L0 24l6.14-1.61a11.93 11.93 0 0 0 5.9 1.51h.01c6.64 0 12.02-5.38 12.02-12.02 0-3.21-1.25-6.22-3.55-8.4zM12.05 21.5c-1.88 0-3.71-.5-5.3-1.44l-.38-.23-3.64.96.97-3.54-.25-.37a9.48 9.48 0 0 1-1.46-5.1c0-5.24 4.27-9.51 9.52-9.51 2.54 0 4.92.99 6.72 2.78a9.43 9.43 0 0 1 2.78 6.72c0 5.25-4.27 9.53-9.52 9.53zm5.26-7.12c-.29-.15-1.72-.85-1.99-.95-.27-.1-.46-.15-.65.15-.19.29-.75.95-.92 1.14-.17.19-.34.21-.63.06-.29-.15-1.23-.45-2.35-1.44-.87-.78-1.46-1.74-1.63-2.03-.17-.29-.02-.45.13-.6.14-.14.29-.34.43-.51.14-.17.19-.29.29-.48.1-.19.05-.36-.02-.51-.07-.15-.65-1.57-.89-2.15-.23-.56-.47-.49-.65-.5h-.56c-.19 0-.51.07-.77.36-.26.29-1.01.98-1.01 2.39s1.03 2.77 1.17 2.96c.14.19 2.02 3.09 4.89 4.33.68.29 1.21.46 1.62.59.68.21 1.29.18 1.77.11.54-.08 1.72-.7 1.96-1.38.24-.68.24-1.26.17-1.38-.07-.12-.26-.19-.54-.33z" />
          </svg>
          {contactInfo.phoneNumber}
        </a>
      </>
    )
  },
  {
    question: "Comment s'abonner à TVLUXO ?",
    answer: "Pour vous abonner à TVLUXO, visitez notre site web et choisissez un abonnement adapté à vos besoins. Vous serez redirigé vers un autre site pour finaliser votre paiement. Une fois terminé, vous recevrez vos codes avec des instructions détaillées, étape par étape, pour l'installer sur vos appareils."
  },
  {
    question: "Puis-je utiliser TVLUXO sur plusieurs appareils simultanément ?",
    answer: "Oui, si vous avez un abonnement Gold, vous pouvez regarder sur plusieurs appareils simultanément."
  },
  {
    question: "Pourquoi suis-je redirigé vers un autre site pour finaliser mon achat ?",
    answer: "Pour des transactions sécurisées, vous êtes redirigé vers le site de notre partenaire de paiement de confiance. Une fois votre achat terminé, vous recevrez votre code d'activation TV DIAMON par e-mail. N'hésitez pas à nous contacter pour toute question."
  },
  {
    question: "Ai-je besoin d'une antenne satellite pour utiliser TVLUXO ?",
    answer: "Non, vous vous connectez aux serveurs de TVLUXO via Internet, et vous n'avez pas besoin d'une parabole ou d'un équipement satellite."
  },
  {
    question: "Puis-je payer mon abonnement avec PayPal ?",
    answer: (
      <>
        Oui, vous pouvez payer votre abonnement avec PayPal, Crypto ou d'autres méthodes de paiement spécifiques.  
        Pour ces options de paiement, envoyez-nous un message par WhatsApp :{" "}
        <a href={contactInfo.whatsappUrl} target="_blank" rel="noopener noreferrer" className='text-[#090979] hover:text-[#090979] font-semibold' style={{ display: "inline-flex", alignItems: "center", gap: "4px" }}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M20.52 3.48A11.77 11.77 0 0 0 12.04 0C5.39 0 .02 5.37.02 12.02c0 2.12.55 4.18 1.59 6.01L0 24l6.14-1.61a11.93 11.93 0 0 0 5.9 1.51h.01c6.64 0 12.02-5.38 12.02-12.02 0-3.21-1.25-6.22-3.55-8.4zM12.05 21.5c-1.88 0-3.71-.5-5.3-1.44l-.38-.23-3.64.96.97-3.54-.25-.37a9.48 9.48 0 0 1-1.46-5.1c0-5.24 4.27-9.51 9.52-9.51 2.54 0 4.92.99 6.72 2.78a9.43 9.43 0 0 1 2.78 6.72c0 5.25-4.27 9.53-9.52 9.53zm5.26-7.12c-.29-.15-1.72-.85-1.99-.95-.27-.1-.46-.15-.65.15-.19.29-.75.95-.92 1.14-.17.19-.34.21-.63.06-.29-.15-1.23-.45-2.35-1.44-.87-.78-1.46-1.74-1.63-2.03-.17-.29-.02-.45.13-.6.14-.14.29-.34.43-.51.14-.17.19-.29.29-.48.1-.19.05-.36-.02-.51-.07-.15-.65-1.57-.89-2.15-.23-.56-.47-.49-.65-.5h-.56c-.19 0-.51.07-.77.36-.26.29-1.01.98-1.01 2.39s1.03 2.77 1.17 2.96c.14.19 2.02 3.09 4.89 4.33.68.29 1.21.46 1.62.59.68.21 1.29.18 1.77.11.54-.08 1.72-.7 1.96-1.38.24-.68.24-1.26.17-1.38-.07-.12-.26-.19-.54-.33z" />
          </svg>
          {contactInfo.phoneNumber}
        </a>
      </>
    )
  },
  {
    question: "Ce service TVLUXO fonctionne-t-il dans mon pays ?",
    answer: "TVLUXO fonctionne dans le monde entier, où que vous viviez ou vous trouviez. Tant que vous avez une connexion Internet stable, vous pouvez regarder des milliers de chaînes de télévision."
  }
];

export default function Faq() {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-5 sm:py-12 relative overflow-hidden" id="faq">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-20">
            <div className="h-64 w-full" style={{
                backgroundImage: `radial-gradient(circle, #3b82f6 1px, transparent 1px)`,
                backgroundSize: '20px 20px'
            }}></div>
        </div>
        
        <div className="main-content w-[90%] sm:w-[90%] md:w-[85%] m-auto relative z-10">
            {/* Header */}
            <div className="text-center mb-12">
                <h1 className="text-2xl md:text-3xl lg:text-4xl mx-auto font-extrabold text-blue-900 mb-4 max-w-3xl leading-snug text-center">
                    Questions <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#0a1a5f] to-[#002f9c]">Fréquentes</span>
                </h1>
                <p className="text-sm text-gray-600 max-w-2xl mx-auto leading-relaxed">
                    Trouvez des réponses aux questions courantes sur TVLUXO
                </p>
            </div>
          <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6 max-w-full mx-auto">
            {faqData.map((faq, index) => (
              <div
                key={index}
                className="bg-white border border-gray-100 rounded-2xl p-4 sm:p-6 shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 cursor-pointer"
                onClick={() => toggleFaq(index)}
              >
                <div className="flex items-center justify-between">
                  <h3 className="font-bold text-blue-900 text-sm sm:text-base lg:text-lg pr-3 sm:pr-4 leading-tight">
                    {faq.question}
                  </h3>
                  <div className="flex-shrink-0">
                    {openIndex === index ? (
                      <div className="w-8 h-8 bg-gradient-to-r from-[#0a1a5f] to-[#002f9c] rounded-full flex items-center justify-center">
                        <span className="text-white text-lg font-bold">−</span>
                      </div>
                    ) : (
                      <div className="w-8 h-8 bg-gradient-to-r from-[#0a1a5f] to-[#002f9c] rounded-full flex items-center justify-center">
                        <span className="text-white text-lg font-bold">+</span>
                      </div>
                    )}
                  </div>
                </div>
                
                <div className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`}>
                  <div className="text-gray-600 mt-3 sm:mt-4 pt-3 sm:pt-4 border-t border-gray-200 leading-relaxed text-sm sm:text-base">
                    {faq.answer}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
    </section>
  );
}